export default __webpack_public_path__ + "static/media/img-3.fb0d3bae.jpg";